import React, { createContext, useContext, useState, useEffect } from "react";

const HyperlinkContext = createContext();

export const useHyperlink = () => {
  const context = useContext(HyperlinkContext);
  if (!context) {
    throw new Error("useHyperlink must be used within a HyperlinkProvider");
  }
  return context;
};

export const HyperlinkProvider = ({ children }) => {
  const [hyperlinkFunctions, setHyperlinkFunctions] = useState(null);

  useEffect(() => {
    const loadHyperlinkFunctions = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_HYPERLINK_PATH);
        const jsCode = await response.text();
        const func = new Function(
          jsCode + "; return { getHyperLink, addHyperlinks };"
        );
        const functions = func();
        setHyperlinkFunctions(functions);
      } catch (error) {
        console.error("Failed to load hyperlink functions:", error);
      }
    };

    loadHyperlinkFunctions();
  }, []);

  const getHyperLink = async (type, id, aliasIndex) => {
    if (hyperlinkFunctions) {
      return await hyperlinkFunctions.getHyperLink(type, id, aliasIndex);
    }
    return null;
  };

  const addHyperlinks = async (text) => {
    if (hyperlinkFunctions) {
      return await hyperlinkFunctions.addHyperlinks(text);
    }
    return text;
  };

  return (
    <HyperlinkContext.Provider
      value={{ getHyperLink, addHyperlinks }}
    >
      {children}
    </HyperlinkContext.Provider>
  );
};  